module.exports = __webpack_public_path__ + "static/media/cross.8963ae85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cross.svg
// module id = 212
// module chunks = 0